export default __webpack_public_path__ + "static/media/1941.90d32c94.png";